import DashboardService from '@/core/services/dashboard';
import PowerBiService from '@/core/services/powerBi';
import ReferralService from '@/core/services/referral';
import TeamsService from '@/core/services/teams';
import TenantsService from '@/core/services/tenants';
import { NotificationType } from '@nxtpeople/nxt-styles';
import { Module } from 'vuex';
const dashboardService = new DashboardService();
const teamsService = new TeamsService();
const tenantsService = new TenantsService();
const referralService = new ReferralService();
const powerBiService = new PowerBiService();

const dashboardStore: Module<any, any> = {
   state: {
      tenants: null,
      journeyTeams: null,
      teams: null,
      influx: null,
      ratePerSubmissionState: null,
      ratePerStep: null,
      rate: null,
      resultsPerModule: null,
      startDate: null,
      endDate: null,
      endDateStatus: null,
      startDateStatus: null,
   },

   getters: {
      tenants: (state) => {
         return state.tenants;
      },
      journeyTeams: (state) => {
         return state.journeyTeams;
      },
      teams: (state) => {
         return state.teams;
      },
      influx: (state) => {
         return state.influx;
      },
      ratePerCJS: (state) => {
         return state.ratePerSubmissionState;
      },
      ratePerStep: (state) => {
         return state.ratePerStep;
      },
      rate: (state) => {
         return state.rate;
      },
      resultsPerModule: (state) => {
         return state.resultsPerModule;
      },
      startDate: (state) => {
         return state.startDate;
      },
      endDate: (state) => {
         return state.endDate;
      },
      endDateStatus: (state) => {
         return state.endDateStatus;
      },
      startDateStatus: (state) => {
         return state.startDateStatus;
      },
   },

   mutations: {
      setJourneyTeams(state, newValue) {
         state.journeyTeams = newValue;
      },
      setCompanies(state, newValue) {
         state.tenants = newValue;
      },
      setTeams(state, newValue) {
         state.teams = newValue;
      },
      setInflux(state, newValue) {
         state.influx = newValue;
      },
      setRatePerStep(state, newValue) {
         state.ratePerStep = newValue;
      },
      setRatePerSubmissionState(state, newValue) {
         state.ratePerSubmissionState = newValue;
      },
      setRate(state, newValue) {
         state.rate = newValue;
      },
      setResultsPerModule(state, newValue) {
         state.resultsPerModule = newValue;
      },
      setStartDate(state, newValue) {
         state.startDate = newValue;
      },
      setEndDate(state, newValue) {
         state.endDate = newValue;
      },
      setEndDateStatus(state, newValue) {
         state.endDateStatus = newValue;
      },
      setStartDateStatus(state, newValue) {
         state.startDateStatus = newValue;
      },
   },

   actions: {
      async getJourneyTeams(context) {
         return await teamsService.getJourneyTeams().then((response) => {
            context.commit('setJourneyTeams', response);
            return response;
         });
      },
      async createJourneyTeam(context, { body: body }) {
         return await teamsService
            .addJourneyTeam(body)
            .then((response) => {
               return response;
            })
            .catch((error) => {
               context.dispatch(
                  'addNotification',
                  { notification: { type: NotificationType.Danger, title: error.message } },
                  { root: true }
               );
            });
      },
      async createJourneyTeams(context, { body: body }) {
         return await teamsService
            .addJourneyTeams(body)
            .then((response) => {
               return response;
            })
            .catch((error) => {
               context.dispatch(
                  'addNotification',
                  { notification: { type: NotificationType.Danger, title: error.message } },
                  { root: true }
               );
            });
      },
      async deleteJourneyTeam(context, journeyTeamId) {
         return await teamsService.deleteJourneyTeam(journeyTeamId).then((response) => {
            return response;
         });
      },
      async editJourneyTeam(context, { journeyTeamId, path, value }) {
         var body = [
            {
               op: 'replace',
               path: path,
               value: value,
            },
         ];
         return await teamsService.editJourneyTeam(body, journeyTeamId).then((response) => {
            return response;
         });
      },
      async getTenants(context, query) {
         return await tenantsService.getTenants(query).then((response) => {
            return response;
         });
      },
      async getSetTeams(context, { query }) {
         return await teamsService.getTeams(query).then((response) => {
            return response;
         });
      },
      async getSetInfluxById(context, id) {
         return await dashboardService.getInfluxById(id).then((response) => {
            context.commit('setInflux', response);
            return response;
         });
      },
      async getSetRatePerStepById(context, id) {
         return await dashboardService.getRatePerStepById(id).then((response) => {
            context.commit('setRatePerStep', response);
            return response;
         });
      },
      async getSetRatePerSubmissionState(context, id) {
         return await dashboardService.getRatePerSubmissionState(id).then((response) => {
            context.commit('setRatePerSubmissionState', response);
            return response;
         });
      },
      async getSetRateById(context, id) {
         return await dashboardService.getRateById(id).then((response) => {
            context.commit('setRate', response);
            return response;
         });
      },
      async getSetResultsPerModuleById(context, id) {
         return await dashboardService.getResultsPerModuleById(id).then((response) => {
            context.commit('setResultsPerModule', response);
            return response;
         });
      },
      async getSetTimedInflux(context, { id, cancelToken }) {
         return await dashboardService
            .getTimedInflux(id, context.getters.startDate, context.getters.endDate, cancelToken)
            .then((response) => {
               return response;
            });
      },
      async getSetTimedAnswersPerReferral(context, { id, cancelToken }) {
         return await dashboardService
            .getSetTimedAnswersPerReferral(id, context.getters.startDate, context.getters.endDate, cancelToken)
            .then((response) => {
               return response;
            });
      },
      async getSetInfluxPerSubmissionState(context, { id, cancelToken }) {
         return await dashboardService
            .getInfluxPerSubmissionState(id, context.getters.startDateStatus, context.getters.endDateStatus, cancelToken)
            .then((response) => {
               return response;
            });
      },
      async getReferralSubmissionStateInflux(context, { journeyId, cancelToken }) {
         return await dashboardService.getInfluxPerReferralPerSubmissionState(journeyId, cancelToken).then((response) => {
            return response;
         });
      },
      async getAccessToken(context) {
         return await powerBiService.getAccessToken().then((response) => {
            return response;
         });
      },
   },
};

export default dashboardStore;
